export default {
  translation: {
    common: {
      accept: 'Akceptuje',
      alreadyUser: 'Masz konto?',
      and: 'i',
      backToLogin: 'Powrót do logowania',
      coreNotFound: 'Nie znaleziono rdzenia',
      createAccount: 'Utwórz konto',
      createYourAccount: 'Utwórz konto',
      emailOrUsername: 'Email lub nazwa użytkownika',
      invalidUsernameOrPassword: 'Błędna nazwa użytkownika lub hasło',
      localRegistrationDisabled: 'User local registration is disabled by the administrator',
      login: 'Logowanie',
      logInToBoards: 'Logowanie',
      continueWith: 'Kontynuuj z {{provider}}',
      newToBoards: 'Nowy użytkownik?',
      noInternetConnection: 'Brak połączenia z internetem',
      pageNotFound_title: 'Nie znaleziono strony',
      password: 'Hasło',
      policyNotAccepted: 'Proszę zaakceptować Warunki świadczenia usług i Politykę prywatności',
      privacyPolicy: 'Politykę prywatności',
      register: 'Rejestracja',
      registerWithGoogle: 'Zarejestruj przez Google',
      registrationDisabled: 'Rejestracja użytkowników została wyłączona przez administratora',
      serverConnectionFailed: 'Błąd połączenia z serwerem',
      ssoRegistrationDisabled: 'Rejestracja przez SSO użytkownika została wyłączona przez administratora',
      termsOfService: 'Warunki świadczenia usług',
      togglePasswordVisibility: 'Pokaż/Ukryj hasło',
      unknownError: 'Nieznany błąd, spróbuj ponownie później',
    },

    action: {
      logIn: 'Zaloguj',
    },
  },
};
